import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {JdDrawerComponent} from './drawer.component';
import {OverlayModule} from '@angular/cdk/overlay';

const EXPORT = [JdDrawerComponent];

@NgModule({
  imports: [
    CommonModule,
    OverlayModule
  ],
  declarations: [...EXPORT],
  exports: [...EXPORT]
})
export class JdDrawerModule {
}
